import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { ConfigContext } from '../context/GlobalContext';
import InvoiceDataValidation from '../helper/InvoiceDataValidation';
import { toast } from 'react-toastify';
import { AddCustomer, AddItem, EditCustomer, EditInvoice, EditProformaInvoice } from '../data';
import * as actionType from '../context/actions';
import { Languages } from '../Utils/Languages';
import LoaderView from './LoaderView';
import Country from "../Utils/countriesJson.json";
import CountryFlags from "../Utils/countries.json";
import Currancy from "../Utils/currency.json";
import { getImage } from "../Utils/image_helper";
import axios from "axios";
import BusinessDropdown from "./child/BusinessDropdown";

const ProformaInvoiceEditLayer = () => {

    const { state, dispatch } = useContext(ConfigContext);
    const navigate = useNavigate();

    const dropdownRef = useRef(null);
    const Invoice_Data = state?.PROFORMAINVOICES?.find(invoice => invoice.invoiceId == state?.SELECTEDPROFORMAINVOICES);



    const [isLoading, setIsLoading] = useState(false);
    const [isFetchingGst, setIsFetchingGst] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [invoiceData, setInvoiceData] = useState({
        id: Invoice_Data?.id,
        date: new Date(parseInt(Invoice_Data?.date?.length > 10 ? Invoice_Data?.date : Invoice_Data?.date * 1000)).getTime(),
        creationDate: new Date(parseInt(Invoice_Data?.creationDate?.length > 10 ? Invoice_Data?.creationDate : Invoice_Data?.creationDate * 1000)).getTime(),
        dateDue: new Date(parseInt(Invoice_Data?.dueDate?.length > 10 ? Invoice_Data?.dueDate : Invoice_Data?.dueDate * 1000)).getTime(),
        customer: Invoice_Data?.customer || "",
        address: Invoice_Data?.address || "",
        phone: Invoice_Data?.phone || "",
        dialCode: Invoice_Data?.dialCode || Invoice_Data?.dial_code || "",
        email: Invoice_Data?.email || "",
        customerGSTNo: Invoice_Data?.customerGSTNo || "",
        shippingaddress: Invoice_Data?.shippingaddress || "",
        items: Invoice_Data?.items,
        totalAmount: Invoice_Data?.totalAmount,
        gstPercentage: Invoice_Data?.gstPercetage,
        discountPercetage: Invoice_Data?.discountPercetage,
        discountAmount: Invoice_Data?.discountAmount,
        isPaid: Invoice_Data?.paidFlagKey == "true" ? true : false,
        note: Invoice_Data?.note,
        invoiceId: Invoice_Data?.invoiceId,
        companyId: Invoice_Data?.companyId,
        updatedDate: new Date().getTime(),
        isigst: Invoice_Data?.isigst == "true" ? true : false,
        subtotal: 0.00,
        customerId: Invoice_Data?.customerId?.toString(),
        customInvoiceId: Invoice_Data?.customInvoiceId || Invoice_Data?.id,
        converted: Invoice_Data?.converted || "false",
        currency: Invoice_Data?.currency || "",
        pstPercentage: Invoice_Data?.pstPercentage || null,
        pstAmount: Invoice_Data?.pstAmount || null
    });
    // Reset state when Invoice_Data changes
    useEffect(() => {
        if (Invoice_Data) {
            setInvoiceData(prev => {
                if (prev.invoiceId !== Invoice_Data.invoiceId) {
                    return {

        id: Invoice_Data?.id,
        date: new Date(parseInt(Invoice_Data?.date?.length > 10 ? Invoice_Data?.date : Invoice_Data?.date * 1000)).getTime(),
        creationDate: new Date(parseInt(Invoice_Data?.creationDate?.length > 10 ? Invoice_Data?.creationDate : Invoice_Data?.creationDate * 1000)).getTime(),
        dateDue: new Date(parseInt(Invoice_Data?.dueDate?.length > 10 ? Invoice_Data?.dueDate : Invoice_Data?.dueDate * 1000)).getTime(),
        customer: Invoice_Data?.customer || "",
        address: Invoice_Data?.address || "",
        phone: Invoice_Data?.phone || "",
        dialCode: Invoice_Data?.dialCode || Invoice_Data?.dial_code || "",
        email: Invoice_Data?.email || "",
        customerGSTNo: Invoice_Data?.customerGSTNo || "",
        shippingaddress: Invoice_Data?.shippingaddress || "",
        items: Invoice_Data?.items,
        totalAmount: Invoice_Data?.totalAmount,
        gstPercentage: Invoice_Data?.gstPercetage,
        discountPercetage: Invoice_Data?.discountPercetage,
        discountAmount: Invoice_Data?.discountAmount,
        isPaid: Invoice_Data?.paidFlagKey == "true" ? true : false,
        note: Invoice_Data?.note,
        invoiceId: Invoice_Data?.invoiceId,
        companyId: Invoice_Data?.companyId,
        updatedDate: new Date().getTime(),
        isigst: Invoice_Data?.isigst == "true" ? true : false,
        subtotal: 0.00,
        customerId: Invoice_Data?.customerId?.toString(),
        customInvoiceId: Invoice_Data?.customInvoiceId || Invoice_Data?.id,
        converted: Invoice_Data?.converted || "false",
        currency: Invoice_Data?.currency || "",
        pstPercentage: Invoice_Data?.pstPercentage || null,
        pstAmount: Invoice_Data?.pstAmount || null
    
                    };
                }
                return prev;
            });
        }
    }, [Invoice_Data?.invoiceId]);

    const [error, setError] = useState({
        dateDue: null,
        customer: null,
        phone: null,
        items: [],
    })

    const [openItemDropdownIndex, setOpenItemDropdownIndex] = useState(null);
    const [itemSearches, setItemSearches] = useState(
        invoiceData.items.map((item) => item.name || "")
    );

    const sold_items = state?.ITEMS;
    const [filteredPhoneCountries, setFilteredPhoneCountries] = useState(Country);
    const [searchBuffer, setSearchBuffer] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);






    const wrapperRef = useRef(null); // reference to the container

    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedCustomerItem, setSelectedCustomerItem] = useState(null);
    const [currencySearch, setCurrencySearch] = useState("");
    const [userHasSelectedInvoiceCurrency, setUserHasSelectedInvoiceCurrency] = useState(false);
    const [userHasSelectedDialCode, setUserHasSelectedDialCode] = useState(!!(Invoice_Data?.dialCode || Invoice_Data?.dial_code));

    const customerTaxType = useMemo(() => {
        const currencyCode = selectedCustomerItem?.currencyCode || selectedItem?.currencyCode || state?.CURRENCYCODE;
        let taxType = "TAX";
        if (["EUR", "CZK", "DKK", "HUF", "PLN", "RON", "SEK", "GBP"].includes(currencyCode)) {
            taxType = "VAT";
        } else if (["INR", "AUD"].includes(currencyCode)) {
            taxType = "GST";
        } else if (["CAD"].includes(currencyCode)) {
            taxType = "GST/HST";
        } else if (["MYR"].includes(currencyCode)) {
            taxType = "SST";
        } else if (["IDR"].includes(currencyCode)) {
            taxType = "PPN";
        }
        return taxType;
    }, [selectedCustomerItem?.currencyCode, selectedItem?.currencyCode, state?.CURRENCYCODE]);

    const invoiceTaxType = useMemo(() => {
        const currencyCode = selectedItem?.currencyCode || state?.CURRENCYCODE;
        let taxType = "TAX";
        if (["EUR", "CZK", "DKK", "HUF", "PLN", "RON", "SEK", "GBP"].includes(currencyCode)) {
            taxType = "VAT";
        } else if (["INR", "AUD"].includes(currencyCode)) {
            taxType = "GST";
        } else if (["CAD"].includes(currencyCode)) {
            taxType = "GST/HST";
        } else if (["MYR"].includes(currencyCode)) {
            taxType = "SST";
        } else if (["IDR"].includes(currencyCode)) {
            taxType = "PPN";
        }
        return taxType;
    }, [selectedItem?.currencyCode, state?.CURRENCYCODE]);

    const currencyOptions = useMemo(() => {
        return Currancy.CountryCurrencyResponse?.map(row => {
            const country = CountryFlags?.CurrencyResponse?.find(c => c.isoAlpha2 === row.countryCode);
            return {
                value: row.currencyCode,
                label: (
                    <div className="d-flex align-items-center gap-2">
                        <img
                            src={
                                country?.flag
                                    ? `data:image/png;base64,${country.flag}`
                                    : getImage("euro_flag")
                            }
                            alt="flag"
                            width="25"
                            height="15"
                            style={{ objectFit: "cover", borderRadius: 2 }}
                        />
                        <span>{row.name} ({row.currencyCode} - {row.currencytSymbol})</span>
                    </div>
                ),
                raw: row,
            };
        }) || [];
    }, []);

    const [filteredCurrencyOptions, setFilteredCurrencyOptions] = useState(currencyOptions);

    const selectedCurrencyOption = useMemo(() => {
        return currencyOptions?.find(
            (opt) => opt.raw.name === selectedItem?.name
        );
    }, [currencyOptions, selectedItem]);

    const selectedCustomerCurrencyOption = useMemo(() => {
        return currencyOptions?.find(
            (opt) => opt.raw.name === selectedCustomerItem?.name
        );
    }, [currencyOptions, selectedCustomerItem]);

    const handleItemClick = (result) => {
        setSelectedItem(result);
        const country = CountryFlags?.CurrencyResponse?.find(c => c.isoAlpha2 === result.countryCode);
        if (country) {
            dispatch({ type: 'FLAG', payload: country.flag });
        }
        setInvoiceData((prevData) => ({
            ...prevData,
            currency: result.currencyCode,
        }));
    };

    const handleCurrencySearch = (e) => {
        const value = e.target.value;
        setCurrencySearch(value);
        const trimmed = value.trim().toLowerCase();
        if (trimmed === "") {
            setFilteredCurrencyOptions(currencyOptions);
        } else {
            const filtered = currencyOptions.filter((opt) => {
                const label = String(opt.raw?.name || "").toLowerCase();
                const val = String(opt.value || "").toLowerCase();
                const country = String(opt.raw?.name || "").toLowerCase();
                return label.includes(trimmed) || val.includes(trimmed) || country.includes(trimmed);
            });
            setFilteredCurrencyOptions(filtered);
        }
    };

    const initRef = useRef(false);
    // Reset initRef when Invoice_Data changes
    useEffect(() => {
        initRef.current = false;
    }, [Invoice_Data?.invoiceId]);


    useEffect(() => {
        if (initRef.current) return;

        const invoiceCustomer = state.CUSTOMERS?.find(
            (cust) => cust.customerId?.toString() === Invoice_Data?.customerId?.toString()
        );
        const selectedBusiness = state?.BUSINESSES?.find(b => String(b.companyId) === String(invoiceData.companyId));
        const storedCurrencyCode = Invoice_Data?.currency || selectedBusiness?.currency || state?.CURRENCYCODE || state?.SET_USER?.currency;
        const matchedCurrency = Currancy.CountryCurrencyResponse.find(
            (c) => c.currencyCode === storedCurrencyCode
        );
        if (matchedCurrency) {
            setSelectedItem(matchedCurrency);

            setInvoiceData((prevData) => {
                const newData = {
                    ...prevData,
                    currency: matchedCurrency.currencyCode,
                };
                // Fallback dial code if not found in Invoice_Data
                if (!Invoice_Data?.dialCode && !Invoice_Data?.dial_code) {
                    const matchedCountry = Country?.find(
                        c =>
                            c.code === matchedCurrency.countryCode ||
                            c.iso2 === matchedCurrency.countryCode ||
                            c.sortname === matchedCurrency.countryCode
                    );
                    if (matchedCountry?.dialCode) {
                        newData.dialCode = matchedCountry.dialCode;
                    }
                }
                return newData;
            });

            dispatch({ type: 'SYMBOL', payload: matchedCurrency.currencytSymbol });
            dispatch({ type: 'CURRENCYCODE', payload: matchedCurrency.currencyCode });
            dispatch({ type: 'CURRENCYNAME', payload: matchedCurrency.name });

            const country = CountryFlags?.CurrencyResponse?.find(c => c.isoAlpha2 === matchedCurrency.countryCode);
            if (country) {
                dispatch({ type: 'FLAG', payload: country.flag });
            }
        }

        const storedCustomerCurrencyCode = invoiceCustomer?.currency || selectedBusiness?.currency || state?.CURRENCYCODE || state?.SET_USER?.currency;
        const matchedCustomerCurrency = Currancy.CountryCurrencyResponse.find(
            (c) => c.currencyCode === storedCustomerCurrencyCode
        );
        if (matchedCustomerCurrency) {
            setSelectedCustomerItem(matchedCustomerCurrency);
        }

        if (state.CUSTOMERS && state.CUSTOMERS.length > 0 && (matchedCurrency || matchedCustomerCurrency)) {
            initRef.current = true;
        }
    }, [Invoice_Data, state.CUSTOMERS, invoiceData.companyId, state?.BUSINESSES]);

    // Remove automatic selectedCustomerItem effect that overrode saved invoice states

    // Click outside handler
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
            setOpenItemDropdownIndex(null);
        }
    };

    const hasUpdatedItems = useRef(false);

    useEffect(() => {
        setFilteredPhoneCountries(Country); // on mount or country list change
    }, []);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const calculateTotals = () => {
        const totalAmount = invoiceData.items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

        // Ensure discountPercetage is valid
        const discountPercetage = invoiceData.discountPercetage || 0;
        const discountAmount = (totalAmount * discountPercetage) / 100;

        // Subtotal after discount
        const subtotalAfterDiscount = totalAmount - discountAmount;

        // Ensure gstPercentage is valid
        const gstPercentage = invoiceData.gstPercentage || 0;
        const gstAmount = (subtotalAfterDiscount * gstPercentage) / 100;

        // PST for Canada (CAD)
        const isCAD = selectedItem?.currencyCode === "CAD";
        const pstPercentage = isCAD ? (invoiceData.pstPercentage || 0) : 0;
        const pstAmount = (subtotalAfterDiscount * pstPercentage) / 100;

        // Final grand total after applying GST + PST
        const grandTotal = subtotalAfterDiscount + gstAmount + pstAmount;

        // Update state with new calculated values
        setInvoiceData(prevData => ({
            ...prevData,
            discountAmount: discountAmount.toFixed(2),
            gstAmount: gstAmount.toFixed(2),
            pstAmount: pstAmount.toFixed(2),
            totalAmount: grandTotal.toFixed(2),
            subtotal: totalAmount.toFixed(2)
        }));
    };

    useEffect(() => {
        const Customer = state.CUSTOMERS?.filter(
            (item) => item.companyId === Invoice_Data?.companyId
        );
        setSelectedCustomer(Customer);
    }, []);

    // Auto-update totalAmount and gstAmount when items or gstPercentage change
    useEffect(() => {
        calculateTotals();
    }, [invoiceData.items, invoiceData.gstPercentage, invoiceData.discountPercetage, invoiceData.pstPercentage]);

    // const handleChange = (field, value) => {
    //     setInvoiceData({ ...invoiceData, [field]: value });
    //     setError({ ...error, [field]: null })
    // };

    const addInvoiceItem = () => {
        setInvoiceData(prevState => ({
            ...prevState,
            items: [
                ...prevState.items,
                {
                    srNo: prevState.items?.length + 1,
                    name: null,
                    subtitle: null,
                    quantity: null,
                    price: null,
                    amount: null,
                    creationDate: new Date().getTime()
                }
            ]
        }));
    };

    const fetchCustomerGstDetails = async (gstNumber) => {
        if (!gstNumber || gstNumber.length !== 15) {
            toast.error("Please enter a valid 15-digit GST number.");
            return;
        }

        setIsFetchingGst(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}fetch-gst-data/${gstNumber}`);
            if (response.data.status) {
                const data = response.data.data.taxpayerInfo;
                if (data) {
                    const tradeName = data.tradeNam || data.lgnm || "";
                    const pradr = data.pradr?.addr || {};

                    // Build formatted address
                    const addressParts = [
                        pradr.bno,
                        pradr.bnm,
                        pradr.st,
                        pradr.loc,
                        pradr.dst,
                        pradr.stcd,
                        pradr.pncd
                    ].filter(part => part && part !== "").join(", ");

                    setInvoiceData(prev => ({
                        ...prev,
                        customer: tradeName,
                        address: addressParts,
                    }));
                    toast.success("GST data fetched successfully!");
                }
            } else {
                toast.error(response.data.message || "Failed to fetch GST data.");
            }
        } catch (error) {
            console.error("GST Fetch Error:", error);
            toast.error("Error fetching GST data. Please check the GST number.");
        } finally {
            setIsFetchingGst(false);
        }
    };

    const handleChange = (field, value) => {
        setInvoiceData((prevData) => ({ ...prevData, [field]: value }));
        setError((prevError) => ({ ...prevError, [field]: null }));
    };

    const handleItemChange = (index, field, value) => {
        setInvoiceData((prevData) => ({
            ...prevData,
            items: prevData.items.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            ),
        }));
        setError((prevError) => ({
            ...prevError,
            items: prevError.items.map((error, i) =>
                i === index ? { ...error, [field]: null } : error
            ),
        }))
    };

    const RemoveInvoiceItem = (srNo) => {
        setInvoiceData(prevState => ({
            ...prevState,
            items: prevState.items
                .filter((item, index) => index !== srNo)
                .map((item, index) => ({ ...item, srNo: index + 1 }))
        }));
    };

    const handleSelectCustomer = (customers) => {
        const matchedCountry = Country?.find(
            c =>
                c.code === customers?.countryCode ||
                c.iso2 === customers?.countryCode ||
                c.sortname === customers?.countryCode
        );
        setInvoiceData((prevData) => ({
            ...prevData,
            customer: customers.customer,
            email: customers.email || "",
            phone: customers.phone,
            customerGSTNo: customers.customerGSTNo || "",
            address: customers.address,
            dialCode: customers?.dialCode || matchedCountry?.dialCode || prevData.dialCode,
        }));

        setUserHasSelectedDialCode(true);

        if (customers?.countryCode || customers?.currency) {
            const matchedCurrency = Currancy.CountryCurrencyResponse.find(
                (c) => (customers.countryCode && c.countryCode === customers.countryCode) || c.currencyCode === customers.currency
            );
            if (matchedCurrency) {
                if (!userHasSelectedInvoiceCurrency) {
                    handleItemClick(matchedCurrency);
                }
                setSelectedCustomerItem(matchedCurrency);
            }
        }

        setError((prevError) => ({
            ...prevError,
            customer: null,
            phone: null,
        }));
    };

    useEffect(() => {
        // OnBusinessChange(PARSED_DATA?.business?.companyId)
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const OnBusinessChange = (companyId) => {
        handleChange("companyId", companyId)
        dispatch({
            type: actionType.SELECTEDBUSINESS,
            payload: companyId,
        });
    }

    useEffect(() => {
        if (invoiceData.customerId && !invoiceData.customer) {
            const matchedCustomer = state.CUSTOMERS?.find(
                (cust) => cust.customerId?.toString() === invoiceData.customerId?.toString()
            );

            if (matchedCustomer) {
                setInvoiceData((prev) => ({
                    ...prev,
                    customer: prev.customer || matchedCustomer.customer,
                    email: prev.email || matchedCustomer.email || "",
                    dialCode: prev.dialCode || matchedCustomer.dialCode || "+91",
                    phone: prev.phone || matchedCustomer.phone || "",
                    customerGSTNo: prev.customerGSTNo || matchedCustomer.customerGSTNo || "",
                    address: prev.address || matchedCustomer.address || ""
                }));
            }
        }
    }, [invoiceData.customerId, state.CUSTOMERS]);

    useEffect(() => {
        if (!invoiceData?.items?.length || !sold_items?.length) return;

        const updatedItems = invoiceData.items.map((invItem) => {
            const matchedItem = sold_items.find(
                (soldItem) =>
                    String(soldItem.itemId || soldItem.itemAddedDate) === String(invItem.itemId)
            );
            return matchedItem
                ? {
                    ...invItem,
                    itemId: matchedItem.itemId || matchedItem.itemAddedDate,
                    name: matchedItem.name || invItem.name,
                    subtitle: matchedItem.subtitle ?? invItem.subtitle ?? "",
                    price: matchedItem.price || "0",
                    quantity: invItem.quantity,
                    amount: invItem.quantity * (matchedItem.price || 0),
                }
                : {
                    ...invItem,
                    subtitle: invItem.subtitle || "",
                    price: invItem.price || "0",
                    amount: invItem.quantity * (invItem.price || 0),
                };
        });


        setInvoiceData((prev) => ({
            ...prev,
            items: updatedItems,
        }));
    }, []);

    useEffect(() => {
        if (invoiceData?.items?.length) {
            const names = invoiceData?.items?.map((item) => item.name || "");
            setItemSearches(names);
        }
    }, [invoiceData.items]);


    const OnPressSave = async () => {
        const { isValid, errors } = await InvoiceDataValidation(invoiceData);

        if (!isValid) {
            setIsLoading(false);
            setError(errors);
            return;
        }

        if (!invoiceData.companyId || invoiceData.companyId === "null") return;
        if (invoiceData?.phone && invoiceData?.phone?.length < 10) {
            setIsLoading(false);
            toast.error("Phone number must be at least 10 digits.");
            return;
        }

        const existingInvoiceWithSameId = state?.PROFORMAINVOICES?.find(
            (inv) =>
                inv?.customInvoiceId?.trim().toLowerCase() ===
                invoiceData?.customInvoiceId?.trim().toLowerCase() &&
                inv?.companyId === invoiceData?.companyId &&
                inv?.invoiceId !== invoiceData?.invoiceId
        );

        if (existingInvoiceWithSameId) {
            toast.error("Proforma Invoice ID already exists. Please use a unique ID.");
            return;
        }

        setIsLoading(true);

        try {
            const selectedBusiness = state?.BUSINESSES?.find(b => b.companyId === invoiceData.companyId);
            const targetUid = selectedBusiness?.isShared ? selectedBusiness.ownerUid : state?.USERID;

            const matchedCustomer = state.CUSTOMERS?.find(
                (cust) =>
                    cust.customer?.toLowerCase() === invoiceData.customer?.toLowerCase()
            );

            const finalCustomerId = matchedCustomer ? matchedCustomer.customerId : Date.now().toString();

            const customerPayload = {
                companyId: invoiceData.companyId || "",
                customer: invoiceData.customer?.toString() || "",
                customerGSTNo: invoiceData.customerGSTNo?.toString() || "",
                dialCode: invoiceData?.dialCode?.toString() || "+91",
                phone: invoiceData.phone?.toString() || "",
                email: invoiceData.email?.toString() || "",
                address: invoiceData.address?.toString() || "",
                customerId: finalCustomerId,
                updatedAt: Date.now().toString(),
                currency: selectedCustomerItem?.currencyCode || selectedItem?.currencyCode || invoiceData?.currency || state?.CURRENCYCODE || "",
            };

            if (matchedCustomer) {
                await EditCustomer(state, dispatch, {
                    ...matchedCustomer,
                    ...customerPayload,
                }, targetUid);
            } else {
                await AddCustomer(state, dispatch, {
                    ...customerPayload,
                    createdAt: Date.now().toString(),
                    invoiceCount: "1",
                    invoices: [invoiceData.invoiceId?.toString()],
                    outstanding: invoiceData.totalAmount || 0,
                    totalAmount: invoiceData.totalAmount || 0,
                    totalPaid: "0",
                }, targetUid);
            }

            const processedItems = invoiceData.items.map((item, index) => {
                const matchedItem = state.ITEMS?.find(
                    (existingItem) =>
                        existingItem.name?.toLowerCase() === item.name?.toLowerCase()
                );

                const invoicePrefix = invoiceData.invoiceId?.toString().slice(0, 4);
                const itemId = matchedItem
                    ? matchedItem.itemId
                    : `${Date.now()}${index}${invoicePrefix}`;

                return {
                    ...item,
                    itemId,
                };
            });

            await AddItem(state, dispatch, processedItems, targetUid);

            const updatedInvoiceData = {
                ...invoiceData,
                customerId: finalCustomerId,
                items: processedItems,
                id: invoiceData.id,
                customInvoiceId: invoiceData.customInvoiceId || invoiceData.id,
                currency: selectedItem?.currencyCode || invoiceData?.currency || state?.CURRENCYCODE || "",
            };

            const { success, message } = await EditProformaInvoice(state, dispatch, Invoice_Data?.uniqueID, updatedInvoiceData, targetUid);

            if (success && message === "Invoice updated successfully!") {
                toast.success("Proforma invoice sucessfully updated!");
                navigate(-1);
            } else {
                toast.error("Failed to update the proforma invoice, Please try again!");
            }

        } catch (err) {
            console.error("Edit failed:", err);
            toast.error("An unexpected error occurred while saving the invoice.");
        } finally {
            // ✅ Always hide loader
            setIsLoading(false);
        }
    };




    useEffect(() => {
        setItemSearches(invoiceData.items.map((item) => item.name || ""));
    }, [invoiceData.items?.length]);




    
    if (state?.SELECTEDPROFORMAINVOICES && String(invoiceData?.invoiceId) !== String(state?.SELECTEDPROFORMAINVOICES)) {
        return <LoaderView />;
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                    {/* Left Side - Back/Close Button */}
                    <div className="d-flex align-items-center gap-2">
                        <button
                            onClick={() => { navigate(-1) }}
                        >
                            <i class="fa fa-arrow-left" style={{ fontSize: 18 }}></i>
                        </button>
                        <p className='fw-semibold mb-0' style={{ fontSize: 20 }}>Edit Proforma Invoice</p>
                    </div>

                    <div className="d-flex gap-2 align-items-center flex-wrap">
                        {/* Currency Dropdown */}
                        <div style={{ minWidth: "250px", position: "relative" }}>
                            <div className="dropdown">
                                <button
                                    className="btn btn-outline-primary-600 dropdown-toggle w-100 d-flex justify-content-between align-items-center px-16 py-10 rounded"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <span className="d-flex align-items-center gap-2">
                                        {selectedCurrencyOption ? (
                                            <>
                                                {(() => {
                                                    const flagCountry =
                                                        CountryFlags?.CurrencyResponse?.find(
                                                            c => c.isoAlpha2 === selectedCurrencyOption.raw?.countryCode
                                                        );

                                                    return (
                                                        <img
                                                            src={
                                                                flagCountry?.flag
                                                                    ? `data:image/png;base64,${flagCountry.flag}`
                                                                    : getImage("euro_flag")
                                                            }
                                                            alt="flag"
                                                            width="25"
                                                            height="15"
                                                            style={{
                                                                objectFit: "cover",
                                                                borderRadius: 2,
                                                            }}
                                                        />
                                                    );
                                                })()}

                                                <span>
                                                    {selectedCurrencyOption.raw?.name} (
                                                    {selectedCurrencyOption.raw?.currencyCode} -{" "}
                                                    {selectedCurrencyOption.raw?.currencytSymbol})
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <img
                                                    src={getImage("euro_flag")}
                                                    alt="flag"
                                                    width="25"
                                                    height="15"
                                                    style={{
                                                        objectFit: "cover",
                                                        borderRadius: 2,
                                                    }}
                                                />
                                                <span>Select Country</span>
                                            </>
                                        )}
                                    </span>

                                    <i className="bi bi-chevron-down"></i>
                                </button>

                                <ul
                                    className="dropdown-menu w-100 mt-1 shadow-sm border-0 rounded-3 hide-scrollbar"
                                    style={{ padding: 0 }}
                                >
                                    <li className="py-2 sticky-top z-2">
                                        <input
                                            type="text"
                                            className="form-control countrybackground"
                                            placeholder="Search country..."
                                            value={currencySearch}
                                            onChange={handleCurrencySearch}
                                        />
                                    </li>

                                    <li
                                        style={{ maxHeight: "250px", overflowY: "auto" }}
                                        className="hide-scrollbar"
                                    >
                                        <ul className="list-unstyled mb-0">
                                            {filteredCurrencyOptions.length > 0 ? (
                                                filteredCurrencyOptions.map((option) => (
                                                    <li key={`${option.raw.countryCode}-${option.value}`}>
                                                        <a
                                                            href="#"
                                                            className={`dropdown-item d-flex align-items-center gap-2 px-16 py-10 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${selectedCurrencyOption?.value === option.value
                                                                ? "bg-primary-50 fw-semibold"
                                                                : ""
                                                                }`}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleItemClick(option.raw);
                                                                setUserHasSelectedInvoiceCurrency(true);
                                                                setCurrencySearch("");
                                                            }}
                                                        >
                                                            {option.label}
                                                            {selectedCurrencyOption?.value === option.value && (
                                                                <i className="bi bi-check2 text-primary-600 ms-auto"></i>
                                                            )}
                                                        </a>
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="text-muted text-center small py-2">
                                                    No Country found
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <BusinessDropdown
                            businesses={state?.BUSINESSES || []}
                            selectedCompanyId={invoiceData.companyId}
                            onBusinessChange={() => { }} // Disabled in Edit mode
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
            <div className="card-body py-20">
                <div className="row justify-content-center" id="invoice">
                    <div className="col-lg-12">
                        <div className="shadow-4 border radius-8">
                            <div className="px-20 py-10 border-bottom">
                                <div className="d-flex  flex-wrap justify-content-between align-items-center mb-4">
                                    {/* Invoice ID - Left */}
                                    <h3>
                                        <div className="d-flex align-items-center">
                                            <label className="fs-5 mb-0">
                                                {Languages[state?.LANGUAGE].invoice} #
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control border-0 border-bottom border-black rounded-0 shadow-none px-1 py-0 text-center fs-5 responsive-invoice-id"
                                                value={invoiceData?.customInvoiceId}
                                                onChange={(e) => handleChange("customInvoiceId", e.target.value)}
                                            />
                                        </div>

                                    </h3>

                                    {/* Due Date - Right */}
                                    <div className="col-12 col-md-6">
                                        <div className="row g-2">
                                            <div className="col-12 col-md-6">
                                                <label className="floting-label">{Languages[state?.LANGUAGE].creation_Date}</label>
                                                <input
                                                    type="date"
                                                    className={`form-control ${error.dateDue ? "border-danger" : ""}`}
                                                    value={(invoiceData.date && !isNaN(invoiceData.date)) ? new Date(parseInt(invoiceData.date)).toISOString().split("T")[0] : ""}
                                                    onChange={(e) => handleChange("date", e.target.value ? new Date(e.target.value).getTime() : "")}
                                                    style={{ fontSize: 14 }}
                                                />
                                            </div>

                                            <div className="col-12 col-md-6">
                                                <label className="floting-label">{Languages[state?.LANGUAGE].due_date}</label>
                                                <input
                                                    type="date"
                                                    className={`form-control ${error.dateDue ? "border-danger" : ""}`}
                                                    value={(invoiceData.dateDue && !isNaN(invoiceData.dateDue)) ? new Date(parseInt(invoiceData.dateDue)).toISOString().split("T")[0] : ""}
                                                    onChange={(e) => handleChange("dateDue", e.target.value ? new Date(e.target.value).getTime() : "")}
                                                    min={
                                                        (invoiceData.date && !isNaN(invoiceData.date))
                                                            ? new Date(parseInt(invoiceData.date)).toISOString().split("T")[0]
                                                            : ""
                                                    }
                                                    style={{ fontSize: 14 }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* {error.dateDue && (
                                        <span className="tooltip-container text-danger ms-2">
                                            <i className="fa-solid fa-circle-exclamation"></i>
                                            <span className="tooltip-text">Please select date!</span>
                                        </span>
                                    )} */}
                                </div>

                                <div className="row justify-content-between g-3 mt-2">
                                    {/* <h6 className="text-md">Customer Details:</h6> */}

                                    <div className="col-12">
                                        <div className="row mt-2">

                                            {/* Left Section */}
                                            <div className="col-lg-6">
                                                <div className="row">

                                                    {/* Customer Name */}
                                                    <div className="col-md-6 mb-3 d-flex align-items-start gap-3">
                                                        <div style={{ width: "100%", position: "relative" }}>
                                                            <label className="floting-label">
                                                                {Languages[state?.LANGUAGE]?.customer_name}<span className="text-danger">*</span>
                                                            </label>
                                                            <div className={`form-control d-flex align-items-center p-0 ${error.customer ? "border-danger" : ""}`}>
                                                                <div className="dropdown w-100" ref={dropdownRef}>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control border-0 text-start"
                                                                        placeholder="Enter Name..."
                                                                        value={invoiceData.customer}
                                                                        onChange={(e) => {
                                                                            if (e.target.value === "" || e.target.value == null) {
                                                                                setShowDropdown(false);
                                                                            } else {
                                                                                setShowDropdown(true);
                                                                            }
                                                                            handleChange("customer", e.target.value);
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                            if ((e.key >= '0' && e.key <= '9') || (e.keyCode >= 96 && e.keyCode <= 105)) {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            background: "transparent",
                                                                            outline: "none",
                                                                            fontSize: 14,
                                                                            paddingLeft: 20,
                                                                            font: "inherit",
                                                                        }}
                                                                    />
                                                                    {showDropdown && selectedCustomer.some(customer =>
                                                                        customer.customer?.toLowerCase().includes(invoiceData?.customer?.toLowerCase())
                                                                    ) && (
                                                                            <ul className="dropdown-menu w-100 show" style={{ maxHeight: "300px", overflowY: "auto", padding: "10px" }}>
                                                                                {selectedCustomer
                                                                                    .filter(customer => customer.customer?.toLowerCase().includes(invoiceData?.customer?.toLowerCase()))
                                                                                    .map((customer, index) => (
                                                                                        <li key={index}>
                                                                                            <button
                                                                                                className="dropdown-item px-16 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                                                                type="button"
                                                                                                style={{ height: "auto" }}
                                                                                                onClick={() => { handleSelectCustomer(customer); setShowDropdown(false); }}
                                                                                            >
                                                                                                {customer.customer}
                                                                                            </button>
                                                                                        </li>
                                                                                    ))}
                                                                            </ul>
                                                                        )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {error.customer && (
                                                            <span className="tooltip-container text-danger ms-2" style={{ zIndex: 1 }}>
                                                                <i className="fa-solid fa-circle-exclamation"></i>
                                                                <span className="tooltip-text">{Languages[state?.LANGUAGE]?.customer_name_error || "Please enter valid name!"}</span>
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-md-6 mb-3 d-flex align-items-start gap-3">
                                                        <div style={{ width: "100%", position: "relative" }}>
                                                            <label className="floting-label">{Languages[state?.LANGUAGE]?.email}</label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                value={invoiceData.email}
                                                                onChange={(e) => handleChange("email", e.target.value)}
                                                                placeholder={Languages[state?.LANGUAGE]?.enter_email}
                                                                style={{ fontSize: 14 }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Currency Selector */}
                                                    <div className="col-6 col-md-6 mb-3 d-flex align-items-start gap-3">
                                                        <div style={{ width: "100%", position: "relative" }}>
                                                            <div className="dropdown">
                                                                <button
                                                                    className="btn btn-outline-primary-600 dropdown-toggle w-100 d-flex justify-content-between align-items-center px-16 py-10 rounded"
                                                                    type="button"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <span className="d-flex align-items-center gap-2">
                                                                        {selectedCustomerCurrencyOption ? (
                                                                            <>
                                                                                {(() => {
                                                                                    const flagCountry = CountryFlags?.CurrencyResponse?.find(c => c.isoAlpha2 === selectedCustomerCurrencyOption.raw?.countryCode);
                                                                                    return (
                                                                                        <img
                                                                                            src={flagCountry?.flag ? `data:image/png;base64,${flagCountry.flag}` : getImage("euro_flag")}
                                                                                            alt="flag"
                                                                                            width="25"
                                                                                            height="15"
                                                                                            style={{ objectFit: "cover", borderRadius: 2 }}
                                                                                        />
                                                                                    );
                                                                                })()}
                                                                                <span>{selectedCustomerCurrencyOption.raw?.name} ({selectedCustomerCurrencyOption.raw?.currencyCode} - {selectedCustomerCurrencyOption.raw?.currencytSymbol})</span>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <img src={getImage("euro_flag")} alt="flag" width="25" height="15" style={{ objectFit: "cover", borderRadius: 2 }} />
                                                                                <span>Select Country</span>
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                    <i className="bi bi-chevron-down"></i>
                                                                </button>
                                                                <ul className="dropdown-menu w-100 mt-1 shadow-sm border-0 rounded-3 hide-scrollbar" style={{ padding: 0 }}>
                                                                    <li className="py-2 sticky-top z-2">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control countrybackground"
                                                                            placeholder="Search country..."
                                                                            value={currencySearch}
                                                                            onChange={handleCurrencySearch}
                                                                        />
                                                                    </li>
                                                                    <li style={{ maxHeight: "250px", overflowY: "auto" }} className="hide-scrollbar">
                                                                        <ul className="list-unstyled mb-0">
                                                                            {filteredCurrencyOptions.length > 0 ? (
                                                                                filteredCurrencyOptions.map((option) => (
                                                                                    <li key={`${option.raw.countryCode}-${option.value}`}>
                                                                                        <a
                                                                                            href="#"
                                                                                            className={`dropdown-item d-flex align-items-center gap-2 px-16 py-10 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${selectedCustomerCurrencyOption?.value === option.value ? "bg-primary-50 fw-semibold" : ""}`}
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                setSelectedCustomerItem(option.raw);
                                                                                                setCurrencySearch("");
                                                                                                setFilteredCurrencyOptions(currencyOptions);
                                                                                                if (!userHasSelectedInvoiceCurrency) {
                                                                                                    handleItemClick(option.raw);
                                                                                                }
                                                                                                if (!userHasSelectedDialCode) {
                                                                                                    const matchedDialCountry = Country.find(c => c.code === option.raw.countryCode);
                                                                                                    if (matchedDialCountry) {
                                                                                                        handleChange("dialCode", matchedDialCountry.dialCode)
                                                                                                    }
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            {option.label}
                                                                                            {selectedCustomerCurrencyOption?.value === option.value && (
                                                                                                <i className="bi bi-check2 text-primary-600 ms-auto"></i>
                                                                                            )}
                                                                                        </a>
                                                                                    </li>
                                                                                ))
                                                                            ) : (
                                                                                <li className="text-muted text-center small py-2">No Country found</li>
                                                                            )}
                                                                        </ul>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* GST Number */}
                                                    <div className="col-md-6 mb-3 d-flex align-items-start gap-3">
                                                        <div style={{ width: "100%", position: "relative" }}>
                                                            <div className="input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={invoiceData.customerGSTNo}
                                                                    onChange={(e) =>
                                                                        handleChange("customerGSTNo", (customerTaxType === "GST" && !(selectedCustomerItem?.currencyCode === "AUD" || selectedItem?.currencyCode === "AUD" || state?.CURRENCYCODE === "AUD")) ? e.target.value.toUpperCase() : e.target.value)
                                                                    }
                                                                    placeholder={`Enter ${(selectedCustomerItem?.currencyCode === "AUD" || selectedItem?.currencyCode === "AUD" || state?.CURRENCYCODE === "AUD" || customerTaxType === "ABN") ? "ABN" : (customerTaxType || 'Tax')} Number`}
                                                                    style={{ fontSize: 14 }}
                                                                />
                                                                {customerTaxType === "GST" && !(selectedCustomerItem?.currencyCode === "AUD" || selectedItem?.currencyCode === "AUD" || state?.CURRENCYCODE === "AUD") && (
                                                                    <button
                                                                        className="btn btn-primary-600 d-flex align-items-center gap-1"
                                                                        type="button"
                                                                        onClick={() => fetchCustomerGstDetails(invoiceData.customerGSTNo)}
                                                                        disabled={isFetchingGst}
                                                                        style={{ zIndex: 1 }}
                                                                    >
                                                                        {isFetchingGst ? (
                                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                        ) : (
                                                                            <Icon icon="solar:globus-search-bold" width="18" />
                                                                        )}
                                                                        Fetch
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Phone Number */}
                                                    <div className="col-md-12 mb-3 d-flex align-items-start gap-3">
                                                        <div style={{ width: "100%", position: "relative" }}>
                                                            <div className="input-group">
                                                                <div className="dropdown">
                                                                    <button
                                                                        className="btn border btn-outline-primary-600 dropdown-toggle d-flex align-items-center gap-1"
                                                                        type="button"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{
                                                                            minWidth: "90px",
                                                                            borderRadius: 0,
                                                                            borderTopLeftRadius: "0.5rem",
                                                                            borderBottomLeftRadius: "0.5rem",
                                                                            zIndex: 1
                                                                        }}
                                                                    >
                                                                        {(() => {
                                                                            const selected = invoiceData?.dialCountryCode
                                                                                ? Country?.find(c => c.code === invoiceData.dialCountryCode)
                                                                                : Country?.find(c => c.dialCode == invoiceData?.dialCode || invoiceData?.dial_code);
                                                                            return (
                                                                                <div className="text-secondary-light">
                                                                                    <img
                                                                                        src={selected?.image}
                                                                                        alt="flag"
                                                                                        style={{ width: "25px", height: "25px", marginRight: "6px" }}
                                                                                    />
                                                                                    {selected?.dialCode || selected?.dial_code}
                                                                                </div>
                                                                            );
                                                                        })()}
                                                                    </button>
                                                                    <ul className="dropdown-menu p-0 shadow-sm border-0 w-auto hide-scrollbar" style={{ zIndex: 1050 }}>
                                                                        <li className="p-2 sticky-top z-1">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Search"
                                                                                value={searchBuffer}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value.toLowerCase().trim();
                                                                                    setSearchBuffer(value);
                                                                                    if (value === "") {
                                                                                        setFilteredPhoneCountries(Country);
                                                                                    } else {
                                                                                        setFilteredPhoneCountries(
                                                                                            Country.filter(c =>
                                                                                                c.name?.toLowerCase().includes(value) ||
                                                                                                c.dialCode?.includes(value)
                                                                                            )
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </li>
                                                                        <div className="hide-scrollbar" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                                                            {filteredPhoneCountries.length > 0 ? (
                                                                                filteredPhoneCountries.map((country) => (
                                                                                    <li key={country.id}>
                                                                                        <a
                                                                                            className="dropdown-item d-flex align-items-center gap-2 px-16 py-10 text-secondary-light"
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                handleChange("dialCode", country.dialCode);
                                                                                                handleChange("dialCountryCode", country.code);
                                                                                                setUserHasSelectedDialCode(true);
                                                                                                setSearchBuffer("");
                                                                                                setFilteredPhoneCountries(Country);
                                                                                            }}
                                                                                        >
                                                                                            <img src={country.image} alt={country.name} style={{ width: "25px", height: "18px", objectFit: "cover" }} />
                                                                                            <span>{country.dialCode}</span>
                                                                                        </a>
                                                                                    </li>
                                                                                ))
                                                                            ) : (
                                                                                <li className="text-center text-secondary-light py-2">No countries found</li>
                                                                            )}
                                                                        </div>
                                                                    </ul>
                                                                </div>
                                                                <input
                                                                    type="tel"
                                                                    className="form-control"
                                                                    value={invoiceData.phone}
                                                                    onChange={(e) => {
                                                                        const onlyNums = e.target.value.replace(/\D/g, "");
                                                                        if (onlyNums.length <= 12) {
                                                                            handleChange("phone", onlyNums);
                                                                        }
                                                                    }}
                                                                    placeholder={Languages[state?.LANGUAGE].enter_phone_number}
                                                                    style={{
                                                                        fontSize: 14,
                                                                        borderTopRightRadius: "0.5rem",
                                                                        borderBottomRightRadius: "0.5rem",
                                                                    }}
                                                                    maxLength={12}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Right Section - Billing Address */}
                                            <div className="col-lg-6">
                                                <div className="row">
                                                    <div className="col-12 mb-3">
                                                        <label className="floting-label">Billing Address</label>
                                                        <textarea
                                                            className="form-control"
                                                            value={invoiceData.address}
                                                            onChange={(e) => {
                                                                handleChange("address", e.target.value);
                                                                e.target.style.height = "auto";
                                                                e.target.style.height = `${e.target.scrollHeight}px`;
                                                            }}
                                                            placeholder={Languages[state?.LANGUAGE].enter_address}
                                                            rows={7}
                                                            style={{ fontSize: 14, resize: "none", overflow: "hidden" }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-12">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="py-10 px-20">
                                <div className="mb-4">
                                    <div className="scroll-sm">
                                        <div className='table-responsive'>
                                            <table className="table bordered-table text-sm w-100" id="invoice-table">
                                                <thead>
                                                    <tr>
                                                        <th className="text-sm">{Languages[state?.LANGUAGE].s_r}</th>
                                                        <th className="text-sm">{Languages[state?.LANGUAGE].items}</th>
                                                        <th className="text-sm">{Languages[state?.LANGUAGE].description}</th>
                                                        <th className="text-sm d-flex align-items-center gap-2">
                                                            {state?.UNIT == "Qty" ? Languages[state?.LANGUAGE].qty : Languages[state?.LANGUAGE].hours}
                                                            <Icon
                                                                icon="mdi:pencil"
                                                                className="text-md cursor-pointer"
                                                                onClick={() => {
                                                                    if (state?.UNIT == "Qty") {
                                                                        dispatch({ type: actionType.UNIT, payload: "Hours" })
                                                                    }
                                                                    else {
                                                                        dispatch({ type: actionType.UNIT, payload: "Qty" })
                                                                    }
                                                                }}
                                                            />
                                                        </th>
                                                        <th className="text-sm">{Languages[state?.LANGUAGE].price}</th>
                                                        <th className="text-sm">{Languages[state?.LANGUAGE].total}</th>
                                                        <th className="text-center text-sm">{Languages[state?.LANGUAGE].action}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {invoiceData?.items?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.srNo || index + 1}</td>
                                                            <td className="position-relative" ref={dropdownRef}>
                                                                <input
                                                                    type="text"
                                                                    className="text-start form-control border-0 border-bottom rounded-0"
                                                                    style={{ padding: 0 }}
                                                                    placeholder={Languages[state?.LANGUAGE]?.enter_item}
                                                                    value={itemSearches[index] || ""}

                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const updatedSearches = [...itemSearches];
                                                                        updatedSearches[index] = value;
                                                                        setItemSearches(updatedSearches);

                                                                        handleItemChange(index, "name", value);
                                                                        setOpenItemDropdownIndex(index); // Show dropdown
                                                                        if (e.target.value === "" || e.target.value == null) {
                                                                            setOpenItemDropdownIndex(null)
                                                                        }
                                                                        else {
                                                                            setOpenItemDropdownIndex(index)
                                                                        }
                                                                    }}
                                                                />

                                                                {/* Show error if any */}
                                                                {error.items[index]?.name && (
                                                                    <span className="tooltip-container text-danger ms-2">
                                                                        <i className="fa-solid fa-circle-exclamation"></i>
                                                                        <span className="tooltip-text">
                                                                            {Languages[state?.LANGUAGE]?.item_error}
                                                                        </span>
                                                                    </span>
                                                                )}

                                                                {/* Dropdown menu for suggestions */}
                                                                {openItemDropdownIndex === index &&
                                                                    Array.isArray(sold_items) &&
                                                                    sold_items.some((item) =>
                                                                        item.name.toLowerCase().includes(itemSearches[index]?.toLowerCase())
                                                                    ) && (
                                                                        <ul
                                                                            className="dropdown-menu show w-100"
                                                                            style={{
                                                                                maxHeight: "300px",
                                                                                overflowY: "auto",
                                                                                padding: "10px",
                                                                                zIndex: 1000,
                                                                            }}
                                                                        >
                                                                            {sold_items
                                                                                .filter((item) =>
                                                                                    item.name.toLowerCase().includes(itemSearches[index]?.toLowerCase())
                                                                                )
                                                                                .map((match, i) => (
                                                                                    <li key={i}>
                                                                                        <button
                                                                                            className="dropdown-item px-16 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                                                            type="button"
                                                                                            onClick={() => {
                                                                                                const updatedItems = [...invoiceData.items];
                                                                                                updatedItems[index] = {
                                                                                                    ...updatedItems[index],
                                                                                                    itemId: match.itemId,
                                                                                                    name: match.name,
                                                                                                    subtitle: match.subtitle || "",
                                                                                                    quantity: 1,
                                                                                                    price: match.price || 0,
                                                                                                    amount: (match.price || 0) * 1,
                                                                                                };
                                                                                                setInvoiceData({ ...invoiceData, items: updatedItems });

                                                                                                const updatedSearches = [...itemSearches];
                                                                                                updatedSearches[index] = match.name;
                                                                                                setItemSearches(updatedSearches);

                                                                                                setOpenItemDropdownIndex(null);
                                                                                            }}
                                                                                        >
                                                                                            {match.name}
                                                                                        </button>
                                                                                    </li>
                                                                                ))}
                                                                        </ul>
                                                                    )}
                                                            </td>

                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control border-0 border-bottom rounded-0'
                                                                    placeholder={Languages[state?.LANGUAGE].description}
                                                                    value={item.subtitle}
                                                                    onChange={(e) => {
                                                                        handleItemChange(
                                                                            index,
                                                                            "subtitle",
                                                                            e.target.value
                                                                        );
                                                                    }}
                                                                    style={{ width: "100%", maxWidth: "200px", padding: 0 }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    placeholder="0"
                                                                    className='form-control border-0 border-bottom rounded-0'
                                                                    value={item.quantity}
                                                                    onChange={(e) => {
                                                                        handleItemChange(
                                                                            index,
                                                                            "quantity",
                                                                            e.target.value
                                                                        );
                                                                        if (item.price) {
                                                                            handleItemChange(
                                                                                index,
                                                                                "amount",
                                                                                e.target.value * item.price
                                                                            );
                                                                        }
                                                                    }}
                                                                    style={{ width: "80px", padding: 2 }}
                                                                />
                                                                {error.items[index]?.quantity && (
                                                                    <span className="tooltip-container text-danger ms-2">
                                                                        <i className="fa-solid fa-circle-exclamation"></i>
                                                                        <span className="tooltip-text">{Languages[state?.LANGUAGE].qty_error}</span>
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className='form-control border-0 border-bottom rounded-0'
                                                                    placeholder="0.00"
                                                                    value={item.price}
                                                                    onChange={(e) => {
                                                                        handleItemChange(
                                                                            index,
                                                                            "price",
                                                                            e.target.value
                                                                        );
                                                                        if (item.quantity) {
                                                                            handleItemChange(
                                                                                index,
                                                                                "amount",
                                                                                e.target.value * item.quantity
                                                                            );
                                                                        }
                                                                    }}
                                                                    style={{ width: "100px", padding: 2 }}
                                                                />
                                                                {error.items[index]?.price && (
                                                                    <span className="tooltip-container text-danger ms-2">
                                                                        <i className="fa-solid fa-circle-exclamation"></i>
                                                                        <span className="tooltip-text">{Languages[state?.LANGUAGE].price_error}</span>
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td>{(() => {
    const activeCurrencyCode = invoiceData?.currency || selectedCustomerItem?.currencyCode || selectedItem?.currencyCode || state?.CURRENCYCODE;
    const activeCurrencyOption = Currancy?.CountryCurrencyResponse?.find(c => c.currencyCode === activeCurrencyCode);
    const displaySymbol = activeCurrencyOption?.currencytSymbol || state?.SYMBOL;
    const displayCode = activeCurrencyOption?.currencyCode || state?.CURRENCYCODE;
    return displaySymbol === "$" ? `${displayCode} ${displaySymbol} ` : `${displaySymbol} `;
})()} {item.amount || "0.00"}</td>
                                                            <td className="text-center">
                                                                {index !== 0 && (<button type="button" className="remove-row">
                                                                    <Icon icon="ic:twotone-close" className="text-danger-main text-xl" onClick={() => RemoveInvoiceItem(index)} />
                                                                </button>)}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>


                                    <div className="d-flex flex-wrap justify-content-between gap-2">
                                        <div>
                                            <div>
                                                <button
                                                    type="button"
                                                    id="addRow"
                                                    className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center gap-1"
                                                    onClick={addInvoiceItem}
                                                >
                                                    <Icon icon="simple-line-icons:plus" className="text-xl" />
                                                    {Languages[state?.LANGUAGE]?.add_new}
                                                </button>
                                            </div>

                                            <div className="mt-3">
                                                <label className="floting-label">{Languages[state?.LANGUAGE]?.note}</label>
                                                <textarea
                                                    name="#0"
                                                    className="form-control"
                                                    rows={3}
                                                    cols={40}
                                                    placeholder={Languages[state?.LANGUAGE]?.enter_note_here}
                                                    value={invoiceData.note}
                                                    onChange={(e) => {
                                                        handleChange("note", e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <table className="text-sm">
                                                <tbody>
                                                    <tr>
                                                        <td className="pe-64">
                                                            <div className="mb-1 d-flex align-items-center">
                                                                <label className="me-2 fw-600">
                                                                    {Languages[state?.LANGUAGE]?.subtotal}:{" "}
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td className="pe-16">
                                                            <span className="text-primary-light fw-semibold">
                                                                {(() => {
    const activeCurrencyCode = invoiceData?.currency || selectedCustomerItem?.currencyCode || selectedItem?.currencyCode || state?.CURRENCYCODE;
    const activeCurrencyOption = Currancy?.CountryCurrencyResponse?.find(c => c.currencyCode === activeCurrencyCode);
    const displaySymbol = activeCurrencyOption?.currencytSymbol || state?.SYMBOL;
    const displayCode = activeCurrencyOption?.currencyCode || state?.CURRENCYCODE;
    return displaySymbol === "$" ? `${displayCode} ${displaySymbol} ` : `${displaySymbol} `;
})()} {invoiceData.subtotal}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="pe-64">
                                                            <div className="d-flex align-items-center">
                                                                <label className="me-2 fw-600">
                                                                    {Languages[state?.LANGUAGE]?.discount}:{" "}
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control border-0 border-bottom rounded-0 px-1 py-0"
                                                                    value={invoiceData.discountPercetage}
                                                                    onChange={(e) =>
                                                                        handleChange("discountPercetage", e.target.value)
                                                                    }
                                                                    placeholder="0"
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        width: "30px",
                                                                        textAlign: "center",
                                                                        backgroundColor: "transparent",
                                                                        borderBottom: "1px solid #ced4da", // Ensure visible bottom border
                                                                    }}
                                                                />
                                                                {"(%)"}
                                                            </div>
                                                        </td>
                                                        <td className="pe-16">
                                                            <span className="text-primary-light fw-semibold">
                                                                {(() => {
    const activeCurrencyCode = invoiceData?.currency || selectedCustomerItem?.currencyCode || selectedItem?.currencyCode || state?.CURRENCYCODE;
    const activeCurrencyOption = Currancy?.CountryCurrencyResponse?.find(c => c.currencyCode === activeCurrencyCode);
    const displaySymbol = activeCurrencyOption?.currencytSymbol || state?.SYMBOL;
    const displayCode = activeCurrencyOption?.currencyCode || state?.CURRENCYCODE;
    return displaySymbol === "$" ? `${displayCode} ${displaySymbol} ` : `${displaySymbol} `;
})()} {invoiceData.discountAmount || "0.00"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className={`pe-64 pb-4 ${selectedItem?.currencyCode === "CAD" ? "" : "border-bottom"}`}>
                                                            <div className="d-flex align-items-center position-relative" ref={wrapperRef}>
                                                                <label className="me-2 fw-600">{invoiceTaxType}</label>

                                                                <input
                                                                    type="number"
                                                                    className="form-control border-0 border-bottom rounded-0 px-1 py-0"
                                                                    value={invoiceData.gstPercentage}
                                                                    onFocus={() => setShowSuggestions(true)}
                                                                    onChange={(e) => {
                                                                        handleChange("gstPercentage", e.target.value);
                                                                        setShowSuggestions(false);
                                                                    }}
                                                                    placeholder="0"
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        width: "60px",
                                                                        textAlign: "center",
                                                                        backgroundColor: "transparent",
                                                                        boxShadow: "none",
                                                                    }}
                                                                />
                                                                {"(%)"}

                                                                {/* Suggestion Dropdown */}
                                                                {showSuggestions && (
                                                                    <div
                                                                        className="dropdown-menu show w-auto"
                                                                        style={{ minWidth: "80px", marginTop: "13rem" }}
                                                                        onMouseDown={(e) => e.preventDefault()} // prevent input blur
                                                                    >
                                                                        {[5, 12, 18, 28].map((rate) => (
                                                                            <button
                                                                                key={rate}
                                                                                type="button"
                                                                                className={`dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 
                                                                                    ? "bg-primary-50"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={() => {
                                                                                    handleChange("gstPercentage", rate);
                                                                                    setShowSuggestions(false);
                                                                                }}
                                                                            >
                                                                                {rate}%
                                                                            </button>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className={`pe-16 ${selectedItem?.currencyCode === "CAD" ? "" : "border-bottom"}`}>
                                                            <span className="text-primary-light fw-semibold">
                                                                {(() => {
    const activeCurrencyCode = invoiceData?.currency || selectedCustomerItem?.currencyCode || selectedItem?.currencyCode || state?.CURRENCYCODE;
    const activeCurrencyOption = Currancy?.CountryCurrencyResponse?.find(c => c.currencyCode === activeCurrencyCode);
    const displaySymbol = activeCurrencyOption?.currencytSymbol || state?.SYMBOL;
    const displayCode = activeCurrencyOption?.currencyCode || state?.CURRENCYCODE;
    return displaySymbol === "$" ? `${displayCode} ${displaySymbol} ` : `${displaySymbol} `;
})()} {invoiceData.gstAmount || "0.00"}
                                                            </span>
                                                        </td>
                                                    </tr>

                                                    {/* PST row — only for Canada (CAD) */}
                                                    {selectedItem?.currencyCode === "CAD" && (
                                                        <tr>
                                                            <td className="pe-64 border-bottom pb-4">
                                                                <div className="d-flex align-items-center">
                                                                    <label className="me-2 fw-600">PST</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control border-0 border-bottom rounded-0 px-1 py-0"
                                                                        value={invoiceData.pstPercentage || ""}
                                                                        onChange={(e) => handleChange("pstPercentage", e.target.value)}
                                                                        placeholder="0"
                                                                        style={{
                                                                            fontSize: "14px",
                                                                            width: "60px",
                                                                            textAlign: "center",
                                                                            backgroundColor: "transparent",
                                                                            boxShadow: "none",
                                                                        }}
                                                                    />
                                                                    {"(%)"}
                                                                </div>
                                                            </td>
                                                            <td className="pe-16 border-bottom">
                                                                <span className="text-primary-light fw-semibold">
                                                                    {(() => {
    const activeCurrencyCode = invoiceData?.currency || selectedCustomerItem?.currencyCode || selectedItem?.currencyCode || state?.CURRENCYCODE;
    const activeCurrencyOption = Currancy?.CountryCurrencyResponse?.find(c => c.currencyCode === activeCurrencyCode);
    const displaySymbol = activeCurrencyOption?.currencytSymbol || state?.SYMBOL;
    const displayCode = activeCurrencyOption?.currencyCode || state?.CURRENCYCODE;
    return displaySymbol === "$" ? `${displayCode} ${displaySymbol} ` : `${displaySymbol} `;
})()}
                                                                    {invoiceData.pstAmount || "0.00"}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )}

                                                    <tr>
                                                        <td className="pe-64 pt-4">
                                                            <span className="text-primary-light fw-semibold">
                                                                {Languages[state?.LANGUAGE]?.payable_amount}:
                                                            </span>
                                                        </td>
                                                        <td className="pe-16 pt-4">
                                                            <span className="text-primary-light fw-semibold">
                                                                {(() => {
    const activeCurrencyCode = invoiceData?.currency || selectedCustomerItem?.currencyCode || selectedItem?.currencyCode || state?.CURRENCYCODE;
    const activeCurrencyOption = Currancy?.CountryCurrencyResponse?.find(c => c.currencyCode === activeCurrencyCode);
    const displaySymbol = activeCurrencyOption?.currencytSymbol || state?.SYMBOL;
    const displayCode = activeCurrencyOption?.currencyCode || state?.CURRENCYCODE;
    return displaySymbol === "$" ? `${displayCode} ${displaySymbol} ` : `${displaySymbol} `;
})()}{" "}
                                                                {invoiceData.totalAmount || "0.00"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-4" style={{ marginTop: 10 }}>
                                                                {/* Checkbox */}
                                                                {invoiceTaxType === "GST" && (selectedItem?.currencyCode === "INR" || state?.CURRENCYCODE === "INR") && (<div className="form-check checked-primary d-flex align-items-center gap-2">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="igstCheckbox"
                                                                        checked={invoiceData.isigst}
                                                                        onChange={() => { handleChange("isigst", !invoiceData.isigst) }}
                                                                    />
                                                                    <label
                                                                        className="form-check-label line-height-1 fw-medium text-secondary-light"
                                                                        htmlFor="igstCheckbox"
                                                                    >
                                                                        {Languages[state?.LANGUAGE].igst}
                                                                    </label>
                                                                </div>)}

                                                                {/* Switch */}
                                                                {/* <div className="form-switch switch-success d-flex align-items-center gap-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        role="switch"
                                                                        id="horizontal3"
                                                                        checked={invoiceData.isPaid}
                                                                        onChange={() => { handleChange("isPaid", !invoiceData.isPaid) }}
                                                                    />
                                                                    <label
                                                                        className="form-check-label line-height-1 fw-medium text-secondary-light"
                                                                        htmlFor="horizontal3"
                                                                        style={{ width: 80 }}
                                                                    >
                                                                        {invoiceData.isPaid ? Languages[state?.LANGUAGE].paid : Languages[state?.LANGUAGE].unpaid}
                                                                    </label>
                                                                </div> */}
                                                            </div>

                                                        </td>
                                                    </tr>
                                                </tbody >
                                            </table >
                                        </div >
                                    </div >
                                </div >

                                <div
                                    className="d-flex gap-2 justify-content-end"
                                    style={{ marginTop: 20 }}
                                >
                                    <button
                                        type="reset"
                                        onClick={() => {
                                            navigate(-1);
                                        }}
                                        className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                                    >
                                        {Languages[state?.LANGUAGE]?.cancel}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                                        onClick={OnPressSave}
                                    >
                                        <Icon icon="simple-line-icons:check" className="text-xl" />
                                        {Languages[state?.LANGUAGE]?.save}
                                    </button>
                                </div>
                            </div >
                        </div >
                    </div >
                </div >
            </div >
            {isLoading && <LoaderView />}
        </div >

    );
};

export default ProformaInvoiceEditLayer;